import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import CancelIcon from "@mui/icons-material/Cancel";

/**
 * Description placeholder
 * @date 6/17/2023 - 3:56:45 PM
 *
 * @export
 *
 * @param {function} action what to do if clicked
 * @param {number} size The size of the icon button (px)
 * @param {string} tooltip overide the default tooltip text
 * @returns {*}
 */
export default function Delete({ action, size,tooltip }) {
  
  if (!size) size = 40;
  return (
    <Tooltip title={tooltip || "Delete"}>
    <IconButton
      color="error"
      onClick={action}
      style={{ height: size, width: size }}
    >
      <CancelIcon />
      </IconButton>
      </Tooltip>
  );
}
